import './qr-code-receipt.scss';

import { ReactComponent as Logo } from '@basqet-dashboard/common/assets/logo.svg';
import PropTypes from 'prop-types';
import React from 'react';
import QRCode from 'react-qr-code';

function QRCodeReceipt({ paymentUrl, paymentLinkName, companyName }) {
  return (
    <div className="qr-code-receipt" id="qr-code-receipt">
      <div className="qr-code-receipt__header">
        <div className="qr-code-receipt__logo">
          <Logo />
        </div>
        <div className="">
          <h1>
            Pay with <span className="text-cursive">USDT</span>
            {''} and other Cryptocurrencies
          </h1>
        </div>
      </div>

      <div className="qr-code-receipt__qr-section">
        <div className="qr-code-receipt__qr-container">
          <QRCode
            value={paymentUrl}
            size={300}
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
          />
        </div>
        <p className="qr-code-receipt__scan-text">Scan to Pay {companyName}</p>
      </div>

      <div className="qr-code-receipt__info-section">
        {paymentLinkName && <h3 className="qr-code-receipt__link-name">{paymentLinkName}</h3>}
        <p className="qr-code-receipt__link-label">Payment Link</p>
        <p className="qr-code-receipt__link-url">{paymentUrl}</p>
      </div>

      <div className="qr-code-receipt__footer">
        <p className="qr-code-receipt__cta-text">
          Sign up and start accepting Crypto payments in 5 minutes at{' '}
          <span className="qr-code-receipt__website text-cursive">basqet.com</span>
        </p>
      </div>
    </div>
  );
}

QRCodeReceipt.propTypes = {
  paymentUrl: PropTypes.string.isRequired,
  paymentLinkName: PropTypes.string,
  companyName: PropTypes.string
};

export { QRCodeReceipt };
